import { Button, useTheme } from "@mui/material";

const ButtonComponent = ({
    label,
    onClick,
    width='fit-content'
}) => {
    const theme = useTheme();

    return (
        <>
            <Button 
                variant="contained"
                sx={{
                    backgroundColor: theme.palette.secondary.main,
                    textTransform: 'none',
                    '&: hover': {
                        transform: 'scale(0.9)'
                    },
                    width: width
                }}
                onClick={onClick}
            >
                {label}
            </Button>
        </>
    );
}

export default ButtonComponent;